import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withTranslations from '../../translations';

import {
  addComment,
  clearComments,
  clearUnreadCommentsNumber,
  getComments,
} from '../../actions/conversation';

import { permissions } from '../../constants/permissions';

import { userHasPermission } from '../../utils/permissions';

import {
  Button,
  Grid,
  Loader,
  Pagination,
  TextField,
} from '../base';

import Comment from './Comment/Comment';

const styles = theme => ({
  conversationSectionContainer: {
    flexDirection: 'column',
    display: 'block',
  },
  addCommentButton: {
    display: 'inline',
    width: `100%`,
    fontSize: 13,

    [theme.breakpoints.up('lg')]: {
      width: `25%`,
      fontSize: 16,
    },
  },
  commentsContainer: {
    marginTop: theme.spacing(4),
  },
  textField: {
    '& fieldset': {
      borderColor: `${theme.palette.secondary.main} !important`,
    },
  },
  noCommentInfo: {
    textAlign: 'center',
    marginTop: theme.spacing(7),

    [theme.breakpoints.up('lg')]: {
      width: '50%',
    },
  },
  addComentContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'flex-end',

    [theme.breakpoints.up('lg')]: {
      width: '50%',
    },

  },
  loaderContainer: {
    margin: '0 auto',
  },
})

class ConversationSection extends Component {
  limit = 7;

  state = {
    offset: this.props.numberOfUnreads !== 0 ? (Math.floor((this.props.numberOfUnreads - 1)/this.limit)) * this.limit : 0,
    comment: '',
  }
  
  componentDidMount() {
    this.props.actions.getComments(this.props.jobId, this.limit);
    this.props.actions.clearUnreadCommentsNumber(this.props.jobId);
  }
  
  componentWillUnmount() {
    this.props.actions.clearComments();
  }

  handleChange = event => this.setState({comment: event.target.value});

  handlePagination = offset => this.setState({offset})

  onCommentSubmmit = async () => {
    if (this.state.comment.trim()) {
      const { actions, jobId } = this.props;
      this.setState({comment: ''});
      await actions.addComment(jobId, this.limit, this.state.comment);
    }
  }
  
  render() {
    const { gt, classes: c, comments, total, user, isFetching } = this.props;
    const { offset, comment } = this.state;
    const page = offset / this.limit;
    
    if (isFetching) {
      return (<div className={c.loaderContainer}><Loader color='secondary'/></div>);
    }

    return (
        comments
        ? <Grid container className={c.conversationSectionContainer}>
          { userHasPermission(user, permissions.PARTICIPATE_IN_CONVERSATION) &&
            <div className={c.addComentContainer}>
                <TextField
                  InputProps={{classes: {focused: c.focus}}}
                  rows='4'
                  label={gt.addComment}
                  margin='normal'
                  fullWidth
                  variant='outlined'
                  multiline
                  className={c.textField}
                  onChange={this.handleChange}
                  value={comment}
                />
                <Button
                  variant='contained'
                  color='secondary'
                  className={c.addCommentButton}
                  onClick={this.onCommentSubmmit}
                >
                  {gt.addComment}
                </Button>
            </div>}
            {comments.length
              ? <div className={c.commentsContainer}>
                  {comments[page].map(comment => <Comment key={comment.id} comment={comment}/>)}
                  <Pagination
                    limit={this.limit}
                    offset={offset}
                    total={total}
                    onClick={(e, offset) => this.handlePagination(offset)}
                  />
                </div>
              : <p className={c.noCommentInfo}>{gt.noComments}</p>}
          </Grid>
        : <p>{gt.noComments}</p>
    )
  }
}

const mapStateToProps = state => ({
  comments: state.comments.comments,
  isFetching: state.comments.isFetching,
  numberOfUnreads: state.comments.numOfUnreadComments,
  total: state.comments.total,
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    addComment: bindActionCreators(addComment, dispatch),
    clearComments: bindActionCreators(clearComments, dispatch),
    clearUnreadCommentsNumber: bindActionCreators(clearUnreadCommentsNumber, dispatch),
    getComments: bindActionCreators(getComments, dispatch),
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withTranslations(ConversationSection, 'ConversationSection')));



// WEBPACK FOOTER //
// ./src/components/ConversationSection/ConversationSection.js